export const CO_GET_USERLISTACCORDINGROLE_LISTING =
  "CO_GET_USERLISTACCORDINGROLE_LISTING"
export const CO_GET_USERLISTACCORDINGROLE_LISTING_SUCCESS =
  "CO_GET_USERLISTACCORDINGROLE_LISTING_SUCCESS"
export const CO_GET_USERLISTACCORDINGROLE_LISTING_FAILED =
  "CO_GET_USERLISTACCORDINGROLE_LISTING_FAILED"
